import { Modal, Form, Input, Button } from 'antd';
import services from '../../../Services';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { formatPhoneNumber } from '../../../Components/dummyConstant/DummyConstant';
import { useEffect } from 'react';
import { updateApplicant } from '../../../Services/hr';
const { hr } = services;


const EditableModal = ({ isModalOpen, handleOk, handleCancel, applicantData,handleFormSubmit }) => {
  const [form] = Form.useForm();
  const location = useLocation();

   

  // Set initial form values based on the applicantData
  form.setFieldsValue({
    first_name: applicantData?.firstName,
    middle_name: applicantData?.middleName ,
    last_name: applicantData?.lastName,
    homePhone: formatPhoneNumber(applicantData?.homePhone),
    email: applicantData?.email,
    // Add more fields as needed
  });
  // const handleFormSubmit = async (values) => {
  //   let id = location?.state?.id;

  //   try {
  //     await hr.updateApplicant({ id, ...values });
  //      

  //     handleOk();
  //   } catch (error) {
  //     console.error('Error updating data:', error);
  //   }
  //    

  // };
 
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };


  return (
    <Modal
      title={(
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold', fontSize: '21px' }}>Applicant Edit</span>

        </div>
      )}
      visible={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}    >
      <Form
        form={form}
        onFinish={handleFormSubmit}
        initialValues={{ /* Set initial values here */ }}
        {...layout}

      >
        {/* Example editable fields */}
        <Form.Item label="First Name" name="first_name"

        >
          <Input />
        </Form.Item>
        <Form.Item label="Middle Name" name="middle_name">
          <Input />
        </Form.Item>
        <Form.Item label="Last Name" name="last_name">
          <Input />
        </Form.Item>
        {/* <Form.Item label="Phone Number" name="homePhone">
          <Input />
        </Form.Item> */}
        <Form.Item label="Phone Number" name="homePhone">
          <Input onChange={(e) => form.setFieldsValue({ homePhone: formatPhoneNumber(e.target.value) })} />
        </Form.Item>
        <Form.Item label="Email Address" name="email">
          <Input />
        </Form.Item>
        <div style={{ marginTop: '20px', textAlign: 'right' }}>
          <Button style={{ marginRight: '05px' }} key="cancel" onClick={handleCancel} >
            Cancel
          </Button>
          <Button style={{ backgroundColor: '#285aad', color: 'white' }} key="submit" type="primary" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditableModal;
